import React from "react";
import Title from "./common/Title";
import AvatarCard from "./common/AvatarCard";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import partnerList from "./common/partnerList"; // This is data mockup and it will be deleted after provided with real data

export default function Partners() {
  return (
    <>
      <Title
        title="Meet Our Conversation Partners"
        description="Meet the refugee talent powering NaTakallam."
      />
      <Grid container spacing={0} justify="center" alignItems="center">
        {partnerList.map((partner, index) => (
          <Grid item sm={6} md={3} key={index}>
            <Box mb={6} px={3}>
              <AvatarCard {...partner} avatarAtcenter={true} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
